export enum classNames {
    XAPP_FORM_BUTTON = "xapp-form-button"
}
